
  import stringTextWidth from "string-pixel-width"

  const textWidth = (props) => {
    const {
        text, 
        fontSize, 
        options
    } = {
        text: "", 
        options: {},
        ...props
    };
    const textOptions = {
        font: 'verdana', bold: false, italic: false,
        ...options,
        ...(fontSize?{size: fontSize}:{})
    }
    return stringTextWidth(text, textOptions);
  }

  const fitText = (props) => {
    const {
        text, 
        maxSize, 
        maxFontSize, 
        minFontSize, 
        options
    } = {
        text: "", 
        maxSize: 0, 
        maxFontSize: 13, 
        minFontSize: 8, 
        options: {},
        ...props
    };
    let fontSize = 0;
    let textSize = 0;
    const textOptions = {
      font: 'verdana', bold: false, italic: false,
      ...options
    }
    
    for ( let fs = maxFontSize; fs > minFontSize; fs--) {
      const calculatedSize = stringTextWidth(text,{ ...textOptions, size: fs});
      if (calculatedSize <= maxSize) {
        fontSize = fs;
        textSize = calculatedSize;
        break;
      }
    }
  
    return {fontSize, textSize}
  }
  
  export {
      textWidth,
      fitText
  }